import PaymentOrderInfo from './PaymentOrderInfo';

export default PaymentOrderInfo;
